import * as React from 'react';

import logo from 'assets/images/logo.png';
import SecurityService from "services/SecurityService";
// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    if (SecurityService.userHasAgency()) {
      document.title = SecurityService.getUserDataParam("agency_name");
    }

    if (SecurityService.userHasAgency() && SecurityService.getUserDataParam("agency_logo")) {
      let link = document.querySelector("link[rel~='icon']");
      link.href = SecurityService.getUserDataParam("agency_favicon");
    }
    
    return (
      <>
        {
          SecurityService.userHasAgency() &&
          SecurityService.getUserDataParam("agency_logo") &&
          <img src={SecurityService.getUserDataParam("agency_logo")} alt="Logo" height="53" />
        }
        
        {
          SecurityService.userHasAgency() &&
          !SecurityService.getUserDataParam("agency_logo") &&
          <img src={logo} alt="Logo" height="53" />
        }
        
        {
          !SecurityService.userHasAgency() &&
          <img src={logo} alt="Logo" height="53" />
        }
      </>
    );
};

export default Logo;
